/* ==========================================================================
   Bitcoin Solo Mining Calculator — JS
   ========================================================================== */
(function () {
  'use strict';

  // Odds math and number formatting are shared with the PDP solo box
  // (assets/solo-mining-math.js), so both show the same numbers.
  var M = window.SoloMiningMath;

  // ─── CONSTANTS ─────────────────────────────────
  var BLOCK_REWARD = 3.125;
  var SECONDS_PER_BLOCK = 600;
  var SOLO_POOL_SLUGS = ['solock', 'publicpool', 'braiinssolo', 'redrockpool', 'solohash', 'futurebitapollo'];
  var POOL_DISPLAY_NAMES = {
    solock: 'Solo CK',
    publicpool: 'Public Pool',
    braiinssolo: 'Braiins Solo',
    redrockpool: 'RedRock Pool',
    solohash: 'SoloHash',
    futurebitapollo: 'FutureBit Apollo'
  };

  // Period definitions (label key + days for math)
  var PERIODS = [
    { key: 'day',   labelKey: 'period_day',   days: 1 },
    { key: 'week',  labelKey: 'period_week',  days: 7 },
    { key: 'month', labelKey: 'period_month', days: 30 },
    { key: 'year',  labelKey: 'period_year',  days: 365 },
    { key: '5y',    labelKey: 'period_5y',    days: 365 * 5 },
    { key: '10y',   labelKey: 'period_10y',   days: 365 * 10 }
  ];

  // ─── STATE ─────────────────────────────────────
  var state = {
    dutyHours: 24,            // hours/day the miner runs (1–24)
    deviceKey: null,
    hashrateInput: 1.3,       // raw user input
    hashrateUnit: 'TH',       // 'GH' | 'TH' | 'PH'
    growthFactor: M.DEFAULT_GROWTH, // network hashrate growth / year — historical avg (~doubles every 2y)
    btcPriceEUR: null,
    networkHashrateTH: null,
    difficulty: null,
    btcPriceOverride: null,
    networkData: null
  };

  var L = window._smcLabels || {};

  // ─── DOM ELEMENTS ──────────────────────────────
  var el = {};
  function cache() {
    el.duty          = document.getElementById('smcDuty');
    el.priceInput    = document.getElementById('smcBtcPriceInput');
    el.priceBadge    = document.getElementById('smcPriceBadge');
    el.priceBadgeTxt = document.getElementById('smcPriceBadgeText');
    el.priceReset    = document.getElementById('smcPriceReset');
    el.priceSuffix   = document.getElementById('smcPriceSuffix');
    el.device        = document.getElementById('smcDevice');
    el.hashrate      = document.getElementById('smcHashrate');
    el.hashrateUnit  = document.getElementById('smcHashrateUnit');
    el.growth        = document.getElementById('smcGrowth');
    el.currency      = document.getElementById('smcCurrencySelect');
  }

  // ─── HELPERS ───────────────────────────────────
  function unitToFactor(unit) {
    // Returns multiplier to convert input value to TH/s
    if (unit === 'GH') return 1 / 1000;
    if (unit === 'TH') return 1;
    if (unit === 'PH') return 1000;
    return 1;
  }

  function getHashrateTH() {
    var v = parseFloat(state.hashrateInput);
    if (!isFinite(v) || v <= 0) return 0;
    return v * unitToFactor(state.hashrateUnit);
  }

  // Duty-scaled hashrate: real device × (hours-per-day / 24).
  // Used for probability calculations (odds, breakdown, chart).
  function getEffectiveHashrateTH() {
    var th = getHashrateTH();
    var duty = parseFloat(state.dutyHours);
    if (!isFinite(duty) || duty <= 0) duty = 24;
    if (duty > 24) duty = 24;
    return th * (duty / 24);
  }

  function pickHashrateUnitForTH(thValue) {
    if (thValue >= 1000) return { unit: 'PH', value: thValue / 1000 };
    if (thValue >= 1)    return { unit: 'TH', value: thValue };
    return { unit: 'GH', value: thValue * 1000 };
  }

  var formatNumber = M.formatNumber;
  var formatBig = M.formatBig;
  var formatPct = M.formatPct;

  // Format money via Shopify's runtime formatMoney — preserves decimals
  // exactly like /pages/bitcoin-mining-calculator does.
  var activeMoneyFormat = window.shopifyMoneyFormat || '{{amount}}';
  var activeCurrencySymbol = window.shopifyCurrencySymbol || '€';
  var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.shopifyCurrencyCode || 'EUR';

  // Currency config — same shape as bitcoin-mining-calculator
  var currencyConfig = {
    EUR: { symbol: '€', format: '€{{amount_with_comma_separator}}' },
    USD: { symbol: '$',      format: '${{amount}}' }
  };

  function formatMoney(amount) {
    var cents = Math.round(amount * 100);
    if (window.Shopify && window.Shopify.formatMoney) {
      var formatted = window.Shopify.formatMoney(cents, activeMoneyFormat);
      if (formatted && formatted.trim().length > 0) {
        if (window.checkForOverrides) {
          return window.checkForOverrides(formatted, activeCurrency, activeCurrencySymbol);
        }
        return formatted;
      }
    }
    var abs = Math.abs(amount);
    var sign = amount < 0 ? '-' : '';
    return sign + activeCurrencySymbol + abs.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getActiveCurrencyRate() {
    // Prefer Shopify runtime currency rate (EUR base) — used as last-resort fallback
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      return parseFloat(window.Shopify.currency.rate) || 1;
    }
    return 1;
  }

  // BTC price expressed in the active currency. Reads from the multi-currency
  // ticker if available; otherwise falls back to EUR × Shopify runtime rate.
  function getBtcPriceActive() {
    var net = state.networkData;
    if (!net) return 0;
    if (net.ticker && net.ticker[activeCurrency] && net.ticker[activeCurrency].last) {
      return net.ticker[activeCurrency].last;
    }
    if (net.ticker && net.ticker.EUR && net.ticker.EUR.last) {
      // Use Shopify runtime rate against EUR
      return net.ticker.EUR.last * getActiveCurrencyRate();
    }
    return (net.btcPriceEUR || 0) * getActiveCurrencyRate();
  }

  function getEffectiveBtcPrice() {
    if (state.btcPriceOverride !== null) return state.btcPriceOverride;
    return getBtcPriceActive();
  }

  // Flip active currency: update format/symbol, clear override, re-derive price + recompute.
  function switchCurrency(code) {
    var config = currencyConfig[code];
    if (!config) return;
    activeCurrency = code;
    activeCurrencySymbol = config.symbol;
    activeMoneyFormat = config.format;
    state.btcPriceOverride = null;       // user-typed price was in the previous currency
    if (el.priceSuffix) el.priceSuffix.textContent = activeCurrencySymbol;
    setPriceLiveBadge();
    applyBtcPriceFromNetwork();
    recompute();
  }

  // Format BTC price for display in the input — full formatted string sans currency symbol
  function formatPriceForInput(price) {
    var formatted = formatMoney(price);
    if (activeCurrencySymbol) {
      formatted = formatted.replace(activeCurrencySymbol, '').trim();
    }
    return formatted;
  }

  // Parse a formatted price string back to a number — verbatim from BMC calc
  function parsePriceInput(str) {
    var cleaned = String(str).replace(/[^\d.,]/g, '');
    var hasDot = cleaned.indexOf('.') !== -1;
    var hasComma = cleaned.indexOf(',') !== -1;
    if (hasDot && hasComma) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    } else if (hasComma) {
      var parts = cleaned.split(',');
      if (parts.length === 2 && parts[1].length === 3) {
        cleaned = cleaned.replace(',', '');
      } else {
        cleaned = cleaned.replace(',', '.');
      }
    }
    return parseFloat(cleaned) || 0;
  }

  // ─── NETWORK DATA FETCH ────────────────────────
  var _netCache = null;
  var _netFetching = null;

  function fetchNetworkData() {
    if (_netCache) return Promise.resolve(_netCache);
    if (_netFetching) return _netFetching;
    _netFetching = Promise.all([
      fetch('https://api.blockchain.info/ticker').then(function (r) { return r.json(); }).catch(function () { return null; }),
      fetch('https://api.blockchain.info/q/getdifficulty').then(function (r) { return r.json(); }).catch(function () { return null; })
    ]).then(function (results) {
      var ticker = results[0];
      var diff = results[1];
      // Fallbacks only used if blockchain.info API fails. Roughly current values.
      var btcPriceEUR = (ticker && ticker.EUR && ticker.EUR.last) ? ticker.EUR.last : 100000;
      var difficulty = (typeof diff === 'number' && diff > 0) ? diff : 1.85e14;
      var networkHashrateTH = difficulty * Math.pow(2, 32) / 600 / 1e12;
      _netCache = {
        ticker: ticker,
        btcPriceEUR: btcPriceEUR,
        difficulty: difficulty,
        networkHashrateTH: networkHashrateTH
      };
      _netFetching = null;
      return _netCache;
    });
    return _netFetching;
  }

  // ─── CORE MATH ─────────────────────────────────
  var pPeriodWithGrowth = M.pPeriodWithGrowth;

  // ─── RENDERERS ─────────────────────────────────

  function renderRewardCard() {
    var network = state.networkData;
    if (!network) return;
    var btcPriceActive = getEffectiveBtcPrice();
    var fiat = BLOCK_REWARD * btcPriceActive;
    var fiatStr = formatMoney(fiat);
    var elFiat = document.querySelector('[data-field="reward_fiat"]');
    if (elFiat) elFiat.textContent = '≈ ' + fiatStr;
    var elBtc = document.querySelector('[data-field="reward_btc"]');
    if (elBtc) elBtc.textContent = formatNumber(BLOCK_REWARD, 3) + ' BTC';
    // Also fill the dynamic intro paragraph (SEO content section).
    var elIntro = document.querySelector('[data-field="intro_reward_value"]');
    if (elIntro) elIntro.textContent = fiatStr;
  }

  function renderBreakdown() {
    var hashrateTH = getEffectiveHashrateTH();
    var network = state.networkData;
    if (!network) return;
    var body = document.querySelector('[data-field="breakdown_body"]');
    if (!body) return;
    var html = '';
    for (var i = 0; i < PERIODS.length; i++) {
      var per = PERIODS[i];
      var p = pPeriodWithGrowth(hashrateTH, network.networkHashrateTH, per.days, state.growthFactor);
      var oddsN = p > 0 ? 1 / p : 0;
      var label = L['label_per_' + per.key] || per.key;
      html += '<tr>'
        + '<td class="_21e-text-p-s">' + label + '</td>'
        + '<td class="_21e-text-p-s">' + formatPct(p) + '</td>'
        + '<td class="_21e-text-p-s">' + (L.one_in || '1 in') + ' ' + formatBig(oddsN) + '</td>'
        + '</tr>';
    }
    body.innerHTML = html;
  }

  function renderPerspective() {
    var hashrateTH = getEffectiveHashrateTH();
    var network = state.networkData;
    if (!network) return;
    var elList = document.querySelector('[data-field="perspective_list"]');
    if (!elList) return;
    var pYear = pPeriodWithGrowth(hashrateTH, network.networkHashrateTH, 365, state.growthFactor);
    var oddsYear = pYear > 0 ? 1 / pYear : 0;
    var items = [
      { label: '💰 ' + (L.cmp_euromillions || 'Winning EuroMillions jackpot'), odds: 139838160 },
      { label: '☄️ ' + (L.cmp_meteorite || 'Being hit by a meteorite'), odds: 1664000 },
      { label: '🃏 ' + (L.cmp_poker || 'Being dealt a royal flush'), odds: 649740 },
      { label: '⚡ ' + (L.cmp_lightning || 'Being struck by lightning'), odds: 500000 },
      { label: '⛏️ ' + (L.cmp_solo_block || 'Finding a solo Bitcoin block') + ' (' + (oddsYear > 0 ? (L.cmp_solo_block_qualifier || 'your hashrate') : '—') + ')', odds: oddsYear, highlight: true },
      { label: '⛳ ' + (L.cmp_golf || 'Hitting a hole in one'), odds: 12500 },
      { label: '🎲 ' + (L.cmp_dice || 'Rolling 5 sixes in a row'), odds: 7776 }
    ];
    items.sort(function (a, b) { return b.odds - a.odds; });
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var cls = it.highlight ? ' smc-perspective__row--active' : '';
      html += '<div class="smc-perspective__row' + cls + '">'
        + '<span class="smc-perspective__row-label">' + it.label + '</span>'
        + '<span class="smc-perspective__row-value">' + (L.one_in || '1 in') + ' ' + formatBig(it.odds) + '</span>'
        + '</div>';
    }
    elList.innerHTML = html;
  }

  // ─── ATTEMPT COUNTER ───────────────────────────
  // Accumulates incrementally so hashrate/device changes apply from the moment
  // they happen — never retroactively rewrite past hashes.
  var _attemptLastTick = null;
  var _attemptHashes = 0;
  var _attemptRaf = null;

  function renderAttemptsTick() {
    var elCount = document.querySelector('[data-field="attempts_count"]');
    if (!elCount) return;
    var now = Date.now();
    if (_attemptLastTick === null) _attemptLastTick = now;
    var dt = (now - _attemptLastTick) / 1000;
    _attemptLastTick = now;
    var hashrateTH = getHashrateTH();
    _attemptHashes += hashrateTH * 1e12 * dt;
    elCount.textContent = formatNumber(Math.round(_attemptHashes));
    _attemptRaf = window.requestAnimationFrame(renderAttemptsTick);
  }

  function renderAttemptsNote() {
    var elNote = document.querySelector('[data-field="attempts_note"]');
    if (!elNote) return;
    var template = L.attempts_note || 'Each tries to be the lucky one. Network: [network] EH/s.';
    var network = state.networkData;
    var nh = network ? formatNumber(network.networkHashrateTH / 1e6, 1) : '—';
    elNote.textContent = template.replace('[network]', nh);
  }

  function startAttempts() {
    if (_attemptRaf) return;
    _attemptLastTick = Date.now();
    _attemptHashes = 0;
    renderAttemptsTick();
  }

  // ─── SOLO-BLOCK TICKER ─────────────────────────
  var _tickerCache = null;
  var _tickerLastTopId = null;

  function fetchSoloBlocks() {
    var requests = SOLO_POOL_SLUGS.map(function (slug) {
      return fetch('https://mempool.space/api/v1/mining/pool/' + slug + '/blocks')
        .then(function (r) { return r.ok ? r.json() : []; })
        .catch(function () { return []; });
    });
    return Promise.all(requests).then(function (lists) {
      var merged = [];
      for (var i = 0; i < lists.length; i++) {
        var arr = lists[i] || [];
        for (var j = 0; j < arr.length; j++) {
          var b = arr[j];
          if (!b || !b.timestamp) continue;
          merged.push(b);
        }
      }
      merged.sort(function (a, b) { return b.timestamp - a.timestamp; });
      return merged.slice(0, 5);
    });
  }

  function relativeTime(ts) {
    var now = Math.floor(Date.now() / 1000);
    var diff = Math.max(0, now - ts);
    if (diff < 90) return L.ticker_ago_just_now || 'just now';
    if (diff < 3600) return (L.ticker_ago_minutes || '[n] min ago').replace('[n]', Math.round(diff / 60));
    if (diff < 86400 * 2) return (L.ticker_ago_hours || '[n]h ago').replace('[n]', Math.round(diff / 3600));
    return (L.ticker_ago_days || '[n]d ago').replace('[n]', Math.round(diff / 86400));
  }

  function renderTicker(blocks) {
    var elList = document.querySelector('[data-field="ticker_list"]');
    if (!elList) return;
    if (!blocks || !blocks.length) {
      elList.innerHTML = '<li class="smc-ticker__empty _21e-text-p-s">' + (L.ticker_empty || 'No recent solo blocks found.') + '</li>';
      return;
    }
    var btcPriceActive = getEffectiveBtcPrice();
    var newTopId = blocks[0].id || blocks[0].height;
    var html = '';
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var rewardSats = (b.extras && b.extras.reward) ? b.extras.reward : 0;
      var rewardBtc = rewardSats / 1e8;
      var rewardFiat = rewardBtc * btcPriceActive;
      var poolName = (b.extras && b.extras.pool && b.extras.pool.name) ? b.extras.pool.name : (POOL_DISPLAY_NAMES[b.extras && b.extras.pool && b.extras.pool.slug] || 'Solo');
      var blockLabel = (L.ticker_block || 'Block #[h]').replace('[h]', formatNumber(b.height));
      var blockUrl = b.id ? ('https://mempool.space/block/' + b.id) : ('https://mempool.space/block/' + b.height);
      var animClass = (i === 0 && _tickerLastTopId !== null && newTopId !== _tickerLastTopId) ? ' smc-ticker__item--new' : '';
      html += '<li class="smc-ticker__item' + animClass + '">'
        + '<a class="smc-ticker__item-link" href="' + escapeHtml(blockUrl) + '" target="_blank" rel="noopener">'
        +   '<span class="smc-ticker__item-main">'
        +     '<span class="smc-ticker__item-pool _21e-text-p _21e-bold">⛏ ' + escapeHtml(poolName) + '</span>'
        +     '<span class="smc-ticker__item-meta _21e-text-p-xs">' + escapeHtml(blockLabel) + ' · ' + escapeHtml(relativeTime(b.timestamp)) + '</span>'
        +   '</span>'
        +   '<span class="smc-ticker__item-reward">'
        +     '<span class="smc-ticker__item-reward-btc _21e-text-p _21e-bold">' + formatNumber(rewardBtc, 4) + ' BTC</span>'
        +     '<span class="smc-ticker__item-reward-fiat _21e-text-p-xs">≈ ' + formatMoney(rewardFiat) + '</span>'
        +   '</span>'
        + '</a>'
        + '</li>';
    }
    _tickerLastTopId = newTopId;
    elList.innerHTML = html;
  }

  function refreshTicker() {
    fetchSoloBlocks().then(function (blocks) {
      _tickerCache = blocks;
      renderTicker(blocks);
    }).catch(function () {
      var elList = document.querySelector('[data-field="ticker_list"]');
      if (elList) elList.innerHTML = '<li class="smc-ticker__error">⚠️ Live data temporarily unavailable.</li>';
    });
  }

  // ─── DEVICE CARD (selected miner or recommendations) ──
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function findVariant(handle, variantId) {
    var data = window.smcProductData;
    if (!data || !data[handle]) return null;
    var product = data[handle];
    if (!product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return { product: product, variant: product.variants[i] };
      }
    }
    return null;
  }

  function formatVariantPrice(cents) {
    if (!isFinite(cents) || cents <= 0) return '';
    return formatMoney(cents / 100);
  }

  function annualOddsFor(hashrateTH) {
    var network = state.networkData;
    if (!network || !hashrateTH) return null;
    var duty = parseFloat(state.dutyHours);
    if (!isFinite(duty) || duty <= 0) duty = 24;
    if (duty > 24) duty = 24;
    var effective = hashrateTH * (duty / 24);
    var p = pPeriodWithGrowth(effective, network.networkHashrateTH, 365, state.growthFactor);
    return p > 0 ? 1 / p : 0;
  }

  function pickRecos(excludeHandle, max) {
    var data = window.smcProductData;
    var soloHandles = window.smcSoloHandles || [];
    if (!data || !soloHandles.length) return [];
    var out = [];
    for (var i = 0; i < soloHandles.length && out.length < max; i++) {
      var h = soloHandles[i];
      if (excludeHandle && h === excludeHandle) continue;
      var prod = data[h];
      if (!prod || !prod.variants || !prod.variants.length) continue;
      var pickVariant = null;
      for (var vi = 0; vi < prod.variants.length; vi++) {
        if (prod.variants[vi].hashrate_th > 0) { pickVariant = prod.variants[vi]; break; }
      }
      if (!pickVariant) continue;
      out.push({ product: prod, variant: pickVariant });
    }
    return out;
  }

  function buildRecoGridHtml(recos) {
    var html = '<div class="smc-device-card__recos">';
    for (var ri = 0; ri < recos.length; ri++) {
      html += buildMinerRowHtml(recos[ri].product, recos[ri].variant);
    }
    html += '</div>';
    return html;
  }

  function buildPriceHtml(price, compareAt) {
    var hasSale = compareAt && compareAt > price;
    if (hasSale) {
      var discountPct = Math.round((compareAt - price) * 100 / compareAt);
      return '<div class="card-price card-price--on-sale smc-device-card__price-block">'
        + '<div class="card-price__row">'
        +   '<span class="card-price__discount">-' + discountPct + '%</span>'
        +   '<span class="card-price__current">' + formatVariantPrice(price) + '</span>'
        + '</div>'
        + '<div class="card-price__compare">' + formatVariantPrice(compareAt) + '</div>'
        + '</div>';
    }
    return '<div class="card-price smc-device-card__price-block">'
      + '<span class="card-price__current">' + formatVariantPrice(price) + '</span>'
      + '</div>';
  }

  function buildMinerRowHtml(p, v) {
    var displayName = p.title;
    if (p.variants.length > 1 && v.title && v.title !== 'Default Title') {
      displayName += ' · ' + v.title;
    }
    var oddsN = annualOddsFor(v.hashrate_th);
    var oddsTxt = oddsN ? ((L.one_in || '1 in') + ' ' + formatBig(oddsN)) : '—';
    var available = v.available !== false && p.available !== false;
    var ctaLabel = available ? (L.device_buy_cta || 'Buy now') : (L.device_sold_out || 'Sold out');
    var priceHtml = v.price ? buildPriceHtml(v.price, v.compare_at_price) : '';
    var ctaTag = available
      ? '<a class="button button--primary smc-device-card__cta" href="' + escapeHtml(p.url) + '"><span>' + escapeHtml(ctaLabel) + '</span></a>'
      : '<button type="button" class="button button--primary smc-device-card__cta" disabled><span>' + escapeHtml(ctaLabel) + '</span></button>';
    return '<div class="smc-device-card__row">'
      +   '<a class="smc-device-card__media" href="' + escapeHtml(p.url) + '" aria-label="' + escapeHtml(p.title) + '">'
      +     (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="120" height="120">' : '')
      +   '</a>'
      +   '<div class="smc-device-card__body">'
      +     '<a class="smc-device-card__product-title _21e-text-p _21e-bold" href="' + escapeHtml(p.url) + '">' + escapeHtml(displayName) + '</a>'
      +     '<p class="smc-device-card__specs _21e-text-p-s">'
      +       escapeHtml(M.formatPlain(v.hashrate_th) + ' TH/s')
      +       (v.power_w ? ' · ' + escapeHtml(M.formatPlain(v.power_w) + ' W') : '')
      +     '</p>'
      +     '<div class="smc-device-card__odds _21e-text-p-s">'
      +       '<span class="smc-device-card__odds-label">' + escapeHtml(L.products_card_odds || 'Your annual odds') + ':</span> '
      +       '<span class="_21e-bold">' + escapeHtml(oddsTxt) + '</span>'
      +     '</div>'
      +   '</div>'
      +   '<div class="smc-device-card__buy">'
      +     priceHtml
      +     ctaTag
      +   '</div>'
      + '</div>';
  }

  function renderDeviceCard() {
    var wrap = document.getElementById('smcDeviceCard');
    if (!wrap) return;
    var data = window.smcProductData;
    if (!data) { wrap.innerHTML = ''; return; }

    var soloHandles = window.smcSoloHandles || [];
    var selectedHandle = null;
    var selectedIsSolo = false;
    var selectedMatch = null;

    if (state.deviceKey) {
      var parts = state.deviceKey.split('|');
      var match = findVariant(parts[0], parts[1]);
      if (match) {
        selectedHandle = parts[0];
        selectedIsSolo = soloHandles.indexOf(selectedHandle) !== -1;
        selectedMatch = match;
      }
    }

    var maxRecos = selectedHandle ? (selectedIsSolo ? 2 : 3) : 3;
    var recos = pickRecos(selectedHandle, maxRecos);

    if (!selectedMatch && !recos.length) { wrap.innerHTML = ''; return; }

    var primaryTitle;
    if (selectedMatch) {
      primaryTitle = L.device_selected_label || 'Your selected miner';
    } else {
      primaryTitle = L.device_recos_heading || 'Recommended solo miners';
    }

    var html = '<div class="smc-device-card__inner">'
      + '<h3 class="_21e-text-p _21e-bold smc-device-card__title">' + escapeHtml(primaryTitle) + '</h3>';

    if (selectedMatch) {
      html += buildMinerRowHtml(selectedMatch.product, selectedMatch.variant);
    }

    if (recos.length) {
      if (selectedMatch) {
        var recoLabel = selectedIsSolo
          ? (L.device_recos_heading_alt || 'Other solo miners')
          : (L.device_recos_heading || 'Recommended solo miners');
        html += '<div class="smc-device-card__divider"></div>'
          + '<h4 class="_21e-text-p-s _21e-bold smc-device-card__recos-title">' + escapeHtml(recoLabel) + '</h4>';
      }
      html += buildRecoGridHtml(recos);
    }

    html += '</div>';
    wrap.innerHTML = html;
  }

  // ─── NETWORK SUMMARY (disclaimer area) ─────────
  function renderNetworkSummary() {
    var network = state.networkData;
    if (!network) return;
    var elSum = document.querySelector('[data-field="network_summary"]');
    if (!elSum) return;
    var template = L.network_summary || '~[hashrate] EH/s · Difficulty [diff]T · BTC ~[price]';
    var price = formatMoney(getBtcPriceActive());
    elSum.textContent = template
      .replace('[hashrate]', formatNumber(network.networkHashrateTH / 1e6, 2))
      .replace('[diff]', formatNumber(network.difficulty / 1e12, 2))
      .replace('[price]', price);
  }

  // ─── DEVICE DROPDOWN ───────────────────────────
  // True when the name already states this hashrate ("Bitaxe 603 Gamma 1.54 TH",
  // "S21 (216 TH / Stock OS)"), so the option label need not repeat it.
  function nameHasHashrate(name, th) {
    var num = String(th).replace('.', '[.,]');
    return new RegExp('(^|[^\\d.,])' + num + '\\s*TH', 'i').test(name);
  }

  function populateDeviceDropdown() {
    var data = window.smcProductData;
    var soloHandles = window.smcSoloHandles || [];
    if (!data || !el.device) return;

    // Build groups, prioritize "Solo Miners" group first
    var groups = {};
    var groupOrder = [];
    var SOLO_GROUP = '⛏️ Solo Miners';

    Object.keys(data).forEach(function (handle) {
      if (handle === '_end') return;
      var p = data[handle];
      if (!p.variants || !p.variants.length) return;
      var isSolo = soloHandles.indexOf(handle) !== -1;
      var groupLabel = isSolo ? SOLO_GROUP : (p.group || 'Other');
      if (!groups[groupLabel]) {
        groups[groupLabel] = [];
        groupOrder.push(groupLabel);
      }
      for (var vi = 0; vi < p.variants.length; vi++) {
        var v = p.variants[vi];
        if (!v.hashrate_th || v.hashrate_th <= 0) continue;
        var name = p.title;
        if (p.variants.length > 1 && v.title && v.title !== 'Default Title') name += ' (' + v.title + ')';
        groups[groupLabel].push({
          handle: handle,
          variantId: v.id,
          name: name,
          hashrate: v.hashrate_th,
          power: v.power_w || 0,
          isSolo: isSolo
        });
      }
    });

    // Sort: Solo Miners group first, then alphabetically
    groupOrder.sort(function (a, b) {
      if (a === SOLO_GROUP) return -1;
      if (b === SOLO_GROUP) return 1;
      return a.localeCompare(b);
    });

    // Sort within group: solo keeps the solo-miner collection order (variants
    // in product order), ASICs by descending hashrate
    for (var gi = 0; gi < groupOrder.length; gi++) {
      var g = groupOrder[gi];
      if (g === SOLO_GROUP) {
        groups[g].forEach(function (item, idx) { item.pos = idx; });
        groups[g].sort(function (a, b) {
          return (soloHandles.indexOf(a.handle) - soloHandles.indexOf(b.handle)) || (a.pos - b.pos);
        });
      } else {
        groups[g].sort(function (a, b) { return b.hashrate - a.hashrate; });
      }
    }

    // Build option groups
    for (var gi2 = 0; gi2 < groupOrder.length; gi2++) {
      var gKey = groupOrder[gi2];
      var items = groups[gKey];
      if (!items.length) continue;
      var optgroup = document.createElement('optgroup');
      optgroup.label = gKey;
      for (var ii = 0; ii < items.length; ii++) {
        var opt = document.createElement('option');
        opt.value = items[ii].handle + '|' + items[ii].variantId + '|' + items[ii].hashrate;
        opt.textContent = nameHasHashrate(items[ii].name, items[ii].hashrate)
          ? items[ii].name
          : items[ii].name + ' · ' + items[ii].hashrate + ' TH/s';
        optgroup.appendChild(opt);
      }
      el.device.appendChild(optgroup);
    }

    // Default: on a PDP (window.smcPreselect) the viewed product's variant, or
    // its first listed variant. Otherwise the first available solo miner, i.e.
    // the first one in the solo-miner collection. Data only carries available
    // variants, and the solo group is sorted first, so that is the first option
    // after "custom". No solo miner in stock → stay on custom.
    var defaultIdx = -1;
    var pre = window.smcPreselect;
    if (pre && pre.handle) {
      var preOpts = el.device.querySelectorAll('option');
      for (var pi = 0; pi < preOpts.length; pi++) {
        var pp = preOpts[pi].value.split('|');
        if (pp[0] !== pre.handle) continue;
        if (defaultIdx === -1) defaultIdx = pi;
        if (String(pp[1]) === String(pre.variantId)) { defaultIdx = pi; break; }
      }
    }
    if (defaultIdx === -1 && groups[SOLO_GROUP] && groups[SOLO_GROUP].length) {
      var firstSolo = groups[SOLO_GROUP][0];
      var allOpts = el.device.querySelectorAll('option');
      var firstVal = firstSolo.handle + '|' + firstSolo.variantId + '|' + firstSolo.hashrate;
      for (var oi = 0; oi < allOpts.length; oi++) {
        if (allOpts[oi].value === firstVal) { defaultIdx = oi; break; }
      }
    }

    if (defaultIdx > 0) {
      el.device.selectedIndex = defaultIdx;
      var parts = el.device.value.split('|');
      var hr = parseFloat(parts[2]);
      if (hr > 0) {
        var picked = pickHashrateUnitForTH(hr);
        state.hashrateInput = picked.value;
        state.hashrateUnit = picked.unit;
        el.hashrate.value = picked.value;
        el.hashrateUnit.value = picked.unit;
        state.deviceKey = el.device.value;
      }
    }
  }

  // ─── PRICE BADGE / OVERRIDE ────────────────────
  function applyBtcPriceFromNetwork() {
    if (state.btcPriceOverride !== null) return;
    if (!state.networkData) return;
    var price = getBtcPriceActive();
    if (el.priceInput) el.priceInput.value = formatPriceForInput(price);
    if (el.priceSuffix) el.priceSuffix.textContent = activeCurrencySymbol;
  }

  function setPriceLiveBadge() {
    if (!el.priceBadge || !el.priceReset) return;
    el.priceBadge.classList.remove('bmc-calc__price-badge--custom');
    if (el.priceBadgeTxt) el.priceBadgeTxt.textContent = L.live || 'Live';
    el.priceReset.hidden = true;
  }

  function setPriceCustomBadge() {
    if (!el.priceBadge || !el.priceReset) return;
    el.priceBadge.classList.add('bmc-calc__price-badge--custom');
    if (el.priceBadgeTxt) el.priceBadgeTxt.textContent = L.custom || 'Custom';
    el.priceReset.hidden = false;
  }

  // ─── EVENT BINDINGS ────────────────────────────
  function bindEvents() {
    // Mining duration (hours/day)
    if (el.duty) {
      el.duty.addEventListener('input', function () {
        var h = parseFloat(el.duty.value);
        if (!isFinite(h) || h <= 0) return;
        if (h > 24) h = 24;
        state.dutyHours = h;
        recompute();
      });
      el.duty.addEventListener('blur', function () {
        var h = parseFloat(el.duty.value);
        if (!isFinite(h) || h <= 0) {
          el.duty.value = 24;
          state.dutyHours = 24;
        } else if (h > 24) {
          el.duty.value = 24;
          state.dutyHours = 24;
        } else {
          el.duty.value = h;
        }
        recompute();
      });
    }

    // Hashrate input + unit
    if (el.hashrate) {
      el.hashrate.addEventListener('input', function () {
        state.hashrateInput = parseFloat(el.hashrate.value) || 0;
        // Unhook from device when user types manually
        state.deviceKey = null;
        if (el.device) el.device.value = 'custom';
        recompute();
      });
    }
    if (el.hashrateUnit) {
      el.hashrateUnit.addEventListener('change', function () {
        state.hashrateUnit = el.hashrateUnit.value;
        state.deviceKey = null;
        if (el.device) el.device.value = 'custom';
        recompute();
      });
    }

    // Device dropdown
    if (el.device) {
      el.device.addEventListener('change', function () {
        if (el.device.value === 'custom') {
          state.deviceKey = null;
          recompute();
          return;
        }
        var parts = el.device.value.split('|');
        var hr = parseFloat(parts[2]);
        if (hr > 0) {
          var picked = pickHashrateUnitForTH(hr);
          state.hashrateInput = picked.value;
          state.hashrateUnit = picked.unit;
          el.hashrate.value = picked.value;
          el.hashrateUnit.value = picked.unit;
          state.deviceKey = el.device.value;
        }
        recompute();
      });
    }

    // Growth factor
    if (el.growth) {
      el.growth.addEventListener('change', function () {
        state.growthFactor = parseFloat(el.growth.value) || 1.0;
        recompute();
      });
    }

    // Currency
    if (el.currency) {
      el.currency.addEventListener('change', function () {
        switchCurrency(el.currency.value);
      });
    }

    // BTC price input override — live formatting w/ cursor preservation
    if (el.priceInput) {
      el.priceInput.addEventListener('input', function () {
        var val = el.priceInput.value;
        var cursorPos = el.priceInput.selectionStart || 0;
        var digitsBeforeCursor = val.slice(0, cursorPos).replace(/[^\d]/g, '').length;

        var n = parsePriceInput(val);
        if (isFinite(n) && n > 0) {
          state.btcPriceOverride = n;
          var formatted = formatPriceForInput(n);
          el.priceInput.value = formatted;

          var newPos = 0;
          var digitCount = 0;
          for (var j = 0; j < formatted.length; j++) {
            if (/\d/.test(formatted[j])) {
              digitCount++;
              if (digitCount === digitsBeforeCursor) { newPos = j + 1; break; }
            }
          }
          if (digitCount < digitsBeforeCursor) newPos = formatted.length;
          try { el.priceInput.setSelectionRange(newPos, newPos); } catch (_) {}

          setPriceCustomBadge();
          recompute();
        }
      });
      el.priceInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') el.priceInput.blur();
      });
      el.priceInput.addEventListener('focus', function () {
        try { el.priceInput.select(); } catch (_) {}
      });
    }

    if (el.priceReset) {
      el.priceReset.addEventListener('click', function () {
        state.btcPriceOverride = null;
        setPriceLiveBadge();
        applyBtcPriceFromNetwork();
        recompute();
      });
    }

    // Tooltips (info buttons)
    var infoBtns = document.querySelectorAll('.bmc-calc__info-btn[data-tooltip]');
    infoBtns.forEach(function (b) {
      var tipId = b.getAttribute('data-tooltip');
      var tip = document.getElementById(tipId);
      if (!tip) return;
      var open = false;
      var toggle = function (force) {
        open = (typeof force === 'boolean') ? force : !open;
        tip.hidden = !open;
        b.setAttribute('aria-expanded', String(open));
      };
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        toggle();
      });
      b.addEventListener('blur', function () { setTimeout(function () { toggle(false); }, 150); });
      document.addEventListener('click', function (e) {
        if (open && !b.contains(e.target) && !tip.contains(e.target)) toggle(false);
      });
    });
  }

  // ─── RECOMPUTE (debounced through next frame) ──
  var _recomputeRaf = null;
  function recompute() {
    if (_recomputeRaf) return;
    _recomputeRaf = window.requestAnimationFrame(function () {
      _recomputeRaf = null;
      renderDeviceCard();
      renderRewardCard();
      renderBreakdown();
      renderPerspective();
      renderAttemptsNote();
      renderNetworkSummary();
      if (_tickerCache) renderTicker(_tickerCache);
    });
  }

  // ─── INIT ──────────────────────────────────────
  function init() {
    cache();
    bindEvents();
    populateDeviceDropdown();
    startAttempts();

    // Initial currency: read Shopify's runtime active currency, fallback to script default.
    if (currencyConfig[activeCurrency] && el.currency) {
      el.currency.value = activeCurrency;
      activeCurrencySymbol = currencyConfig[activeCurrency].symbol;
      activeMoneyFormat = currencyConfig[activeCurrency].format;
      if (el.priceSuffix) el.priceSuffix.textContent = activeCurrencySymbol;
    }

    fetchNetworkData().then(function (data) {
      state.networkData = data;
      applyBtcPriceFromNetwork();
      recompute();
      // Ticker may have rendered before network data arrived → re-render with prices
      if (_tickerCache) renderTicker(_tickerCache);
    });

    // Ticker is left out in PDP mode; don't poll mempool.space for nothing
    if (document.querySelector('[data-field="ticker_list"]')) {
      refreshTicker();
      setInterval(refreshTicker, 60000);
    }
  }

  // Expose for debugging
  window.SoloMiningCalc = { recompute: recompute, state: state, refreshTicker: refreshTicker };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
